import React from 'react';

const {
    hooks: {useDelay},
    css: {prefixCSS}
} = polyphony;

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    wrapper: {
        display: 'inline-block',
        position: 'relative',
        width: '100%',
        maxWidth: 64,
        height: '100%',
        maxHeight: 64
    },
    rectangle: prefixCSS({
        display: 'inline-block',
        position: 'absolute',
        left: 6,
        width: 13,
        animation: 'loader-animation 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite'
    })
};

const Loader = ({color='black', fullscreen=false, style}) => {
    const delayed = useDelay();
    if (!delayed) return null;

    return (
        <div role="alert" aria-busy="true" style={{...styles.container, width: fullscreen ? '100vw' : '100%', height: fullscreen ? '100vh' : '100%', ...style}}>
            <div role="none" style={styles.wrapper}>
                <div role="none" style={prefixCSS({...styles.rectangle, background: color, left: 6, animationDelay: '-0.24s'})}/>
                <div role="none" style={prefixCSS({...styles.rectangle, background: color, left: 26, animationDelay: '-0.12s'})}/>
                <div role="none" style={prefixCSS({...styles.rectangle, background: color, left: 45, animationDelay: '0'})}/>
            </div>
        </div>
    );
};

export default Loader;

